import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";
import store from "redux/store";
import { storage } from "util/storage";
import { getEnvironment } from "util/environment-utils";

const BUGSNAG_KEY = import.meta.env.VITE_BUGSNAG_KEY;
const APP_VERSION = import.meta.env.VITE_APP_VERSION;
const RELEASE_STAGE = import.meta.env.VITE_ENV || getEnvironment();

let isBugsnagInitialized = false;

const silentLogger = {
  debug: () => {},
  info: () => {},
  warn: () => {},
  error: () => {},
};

const resolveUser = () => {
  const state = store.getState();
  return state?.newUser?.user;
};

const resolveUserName = (user) => {
  if (!user) {
    return undefined;
  }
  if (user.name) {
    return user.name;
  }
  const parts = [user.firstName, user.lastName].filter(Boolean);
  if (parts.length) {
    return parts.join(" ").trim();
  }
  return undefined;
};

const attachContext = (event) => {
  const user = resolveUser();
  if (user) {
    const id = user.id || user._id || user.email || "unknown";
    event.setUser(String(id), user.email || undefined, resolveUserName(user));
  }
  const token = storage.get("token");
  if (token) {
    event.addMetadata("auth", { token });
  }
};

export const setupBugsnag = () => {
  if (isBugsnagInitialized || !BUGSNAG_KEY) {
    return;
  }

  Bugsnag.start({
    apiKey: BUGSNAG_KEY,
    appVersion: APP_VERSION,
    releaseStage: RELEASE_STAGE,
    enabledReleaseStages: ["production", "staging", "development"],
    plugins: [new BugsnagPluginReact()],
    logger: import.meta.env.MODE === 'development' ? silentLogger : undefined,
    onError: (event) => {
      attachContext(event);
    },
  });

  BugsnagPerformance.start({
    apiKey: BUGSNAG_KEY,
    appVersion: APP_VERSION,
    releaseStage: RELEASE_STAGE,
  });

  isBugsnagInitialized = true;
};

export const bugsnagNotify = (error, callback) => {
  if (!isBugsnagInitialized || !(error instanceof Error)) {
    return;
  }
  Bugsnag.notify(error, (event) => {
    attachContext(event);
    if (typeof callback === "function") {
      callback(event);
    }
  });
};

export const getBugsnagReactPlugin = () => {
  if (!isBugsnagInitialized) {
    return null;
  }
  return Bugsnag.getPlugin("react");
};

